import { render, staticRenderFns } from "./events-data.vue?vue&type=template&id=73650614"
import script from "./events-data.vue?vue&type=script&lang=js"
export * from "./events-data.vue?vue&type=script&lang=js"
import style0 from "./events-data.vue?vue&type=style&index=0&id=73650614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports